import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import {
    dayBookingSelector,
    makeSelecDayBookingsByDateRange,
} from "../../framework/redux/slices/dayBookingSlice";

export const useSelectDayBookingById = (id: string) => {
    const state = useAppSelector((state) => state.dayBooking);
    return dayBookingSelector.selectById(state, id);
};

export const useSelectDaybookingsByDateRange = (
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.dayBooking);

    const selectDayBookingsByDateRange = useMemo(
        makeSelecDayBookingsByDateRange,
        []
    );
    return selectDayBookingsByDateRange(state, rangeStart, rangeEnd);
};
